export const deepLinkPrefix =
    "brightid://link-verification/http:%2f%2fnode.brightid.org/ethereum/";